export default __webpack_public_path__ + "自定义.png";